import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { getSession } from "@insite/client-framework/Services/SessionService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import Icon from "@insite/mobius/Icon";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    session: state.context.session,
});

interface OwnProps extends WidgetProps {}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface HeaderContainerStyle {
    headerContainer?: InjectableCss;
    headerSection?: InjectableCss;
    borderBottom?: InjectableCss;
    signInborderBottom?: InjectableCss;
    logoSearchContainer?: InjectableCss;
    logo?: InjectableCss;
    search?: InjectableCss;
    login?: InjectableCss;
    myAccount?: InjectableCss;
    signInAccount?: InjectableCss;
    mainNavigation?: InjectableCss;
    cart?: InjectableCss;
    signIn?: HiddenProps;
    loginWrapper?: InjectableCss;
    language?: InjectableCss;
}

export const headerContainerStyle: HeaderContainerStyle = {
    headerContainer: {
        css: css`
            background: white;
            border-bottom: 1px solid #acacac;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        background: black;
                    `,
                    css`
                        background: black;
                    `,
                    css`
                        background: black;
                    `,
                    null,
                    null,
                ]);
            }}
        `,
    },

    headerSection: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            background-color: black;
                        `,
                        null,
                        css`
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            max-width: calc(100% - 40px);
                            margin: 0 auto;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    borderBottom: {
        css: css`
            background-color: black;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        border-bottom: none;
                        width: 100%;
                        order: 2;
                    `,
                    css`
                        border-bottom: none;
                        width: 100%;
                        order: 2;
                    `,
                    css`
                        border-bottom: none;
                        width: 100%;
                        order: 2;
                    `,
                    null,
                    null,
                ]);
            }}
        `,
    },
    signInborderBottom: {
        css: css`
            background-color: black;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        border-bottom: none;
                        width: 100%;
                        order: 2;
                    `,
                    css`
                        border-bottom: none;
                        width: 100%;
                        order: 2;
                    `,
                    css`
                        border-bottom: none;
                        width: 100%;
                        order: 2;
                    `,
                    null,
                    null,
                ]);
            }}
        `,
    },
    logoSearchContainer: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            max-width: 1280px;
            margin: 0 auto;
            padding: 32px 0px;
            max-height: 100px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            max-width: 100% !important;
                            padding: 0px;
                            margin: 21px 0px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            @media only screen and (max-width: 1280px) {
                padding-left: 15px;
                padding-right: 15px;
            }
            @media only screen and (max-width: 992px) {
                padding-left: 0px;
                padding-right: 0px;
            }
        `,
    },
    mainNavigation: {
        css: css`
            max-width: 1440px;
            margin: 0 auto;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            background-color: black;
                        `,
                        null,
                        null,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            > div {
                max-width: 1280px;
                margin: 0 auto;
                justify-content: space-between !important;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            order: 1;
                            margin: 0;
                        `,
                        css``,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    logo: {
        css: css`
            width: 22%;
            padding-top: 5px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: auto;
                            margin: 0 auto;
                            padding-top: 0px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    search: {
        css: css`
            width: 50%;
            margin-left: 16px;
        `,
    },
    login: {
        css: css`
            width: auto;
            display: flex;
            justify-content: center;
            position: relative;
        `,
    },
    loginWrapper:{
        css:css`
        display:flex;
        justify-content: center;
        margin-left: 10px;
        `
    },
    language: {
        css: css`
            width: auto;
            display: flex;
            justify-content: center;
            div {
                width: 100%;
            }
        `,
    },
    signInAccount: {
        css: css`
            width: 12%;
        `,
    },
    myAccount: {
        css: css`
            width: 18%;
            padding-left: 12px;
        `,
    },
    cart: {
        css: css`
            /* > div {
                display: flex;
                justify-content: end;
            } */
        `,
    },
    signIn: {
        css: css`
            > div {
                display: flex;
                justify-content: end;
            }
        `,
    },
};

const styles = headerContainerStyle;

export const HeaderContainer: FC<Props> = ({ id, session }) => {
    return (
        <StyledWrapper {...styles.headerContainer}>
            <StyledWrapper {...styles.headerSection}>
                <StyledWrapper {...(!session.isAuthenticated ? styles.borderBottom : styles.signInborderBottom)}>
                    <StyledWrapper {...styles.logoSearchContainer}>
                        <StyledWrapper {...styles.logo}>
                            <Zone contentId={id} zoneName="Logo" />
                        </StyledWrapper>
                        <Hidden below="lg" {...styles.search}>
                            <StyledWrapper>
                                <Zone contentId={id} zoneName="Search" />
                            </StyledWrapper>
                        </Hidden>
                        <StyledWrapper {...styles.loginWrapper}>
                        <Hidden below="lg" {...styles.login}>
                            <StyledWrapper>
                                <Zone contentId={id} zoneName="whiteCapLogin" />
                            </StyledWrapper>
                        </Hidden>
                        <Hidden below="lg" {...styles.language}>
                            <StyledWrapper>
                                <Zone contentId={id} zoneName="language" />
                            </StyledWrapper>
                        </Hidden>
                        </StyledWrapper>

                        {/* <Hidden below="lg" {...(!session.isAuthenticated ? styles.signInAccount : styles.myAccount)}>
                            <StyledWrapper>
                                <Zone contentId={id} zoneName="MyAccount" />
                            </StyledWrapper>
                        </Hidden> */}
                        {/* <Hidden below="lg" {...styles.cart}> */}
                        <StyledWrapper {...styles.cart}>
                            <Zone contentId={id} zoneName="Cart" />
                        </StyledWrapper>
                        {/* </Hidden> */}

                        {/* {!session.isAuthenticated && (
                            <Hidden below="lg" {...styles.signIn}>
                                <Zone contentId={id} zoneName="SignIn" />
                            </Hidden>
                        )} */}
                    </StyledWrapper>
                </StyledWrapper>
                <StyledWrapper {...styles.mainNavigation}>
                    <Zone contentId={id} zoneName="mainNavigation" />
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(HeaderContainer),
    definition: {
        group: "Basic",
        displayName: "Header Container",
    },
};

export default widgetModule;
